import { useMutation } from 'react-query'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import AuthDataService from 'src/services/auth.service'
import { IUserLogin, LoginUserDto } from 'src/types'

import { ROUTES, STORAGE_KEYS } from 'src/constants'
import { joinAbsRoute } from 'src/common/utils'

const useLogin = () => {
  const { token } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  return useMutation(
    (dto: IUserLogin) => {
      const { state } = location || {}

      const extendedDto: LoginUserDto = { ...dto }

      if (state?.provider === 'x' && state?.userId) {
        extendedDto.connectToXProvider = true
        extendedDto.preRegisteredUserId = state.userId
      }

      return AuthDataService.login({ ...extendedDto, token })
    },
    {
      onSuccess: (data) => {
        if (!data) return

        if (
          'redirectToRegister' in data &&
          typeof data.redirectToRegister !== 'undefined' &&
          data.redirectToRegister
        ) {
          return navigate(`${ROUTES.REGISTER}?email=${data.email}`)
        }

        if (
          'hasFinishedRegistration' in data &&
          typeof data.hasFinishedRegistration !== 'undefined' &&
          !data.hasFinishedRegistration
        ) {
          return navigate(`${ROUTES.REGISTER_FINISH}?userId=${data.id}&email=${data.email}`)
        }

        if ('tokenTwoFA' in data) {
          return navigate(
            `${ROUTES.LOGIN_2FA_VERIFY}?token=${data.tokenTwoFA}&method=${data.methodTwoFA}`,
          )
        }

        if ('journeyRedirect' in data) {
          if (data?.accessToken && data?.refreshToken) {
            localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, data.accessToken)
            localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, data.refreshToken)
          }

          setTimeout(() => {
            window.location.replace(data.journeyRedirect!)
          }, 1000)
          return
        }

        if ('accessToken' in data) {
          localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, data.accessToken)
          localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, data.refreshToken)

          navigate(
            data?.customer
              ? joinAbsRoute(ROUTES.USER, ROUTES.USER_DASHBOARD)
              : data.accountId
                ? joinAbsRoute(ROUTES.ACCOUNTS, data.accountId, ROUTES.DASHBOARD)
                : data.scannerAccountId
                  ? joinAbsRoute(ROUTES.ACCOUNTS, data.scannerAccountId, ROUTES.SCAN_HISTORY)
                  : joinAbsRoute(ROUTES.ACCOUNTS),
          )
        }
      },
    },
  )
}
export { useLogin }
